export const GET_DRIVER_ATTENDANCE_REQUEST = "GET_DRIVER_ATTENDANCE_REQUEST";
export const GET_DRIVER_ATTENDANCE_SUCCESS = "GET_DRIVER_ATTENDANCE_SUCCESS";
export const GET_DRIVER_ATTENDANCE_FAILURE = "GET_DRIVER_ATTENDANCE_FAILURE";

export const getDriverAttendanceRequest = (data: any) => ({
    type: GET_DRIVER_ATTENDANCE_REQUEST,
    payload: data
});


export const approveAttendanceRequest = (
    cabid: string,
    openingKM: string,
    username: string
) => ({
    type: "APPROVE_ATTENDANCE_REQUEST" as const,
    payload: { cabid, openingKM, username },
});

export const approveAttendanceSuccess = (message: string) => ({
    type: "APPROVE_ATTENDANCE_SUCCESS" as const,
    payload: message,
});

export const approveAttendanceFailure = (error: string) => ({
    type: "APPROVE_ATTENDANCE_FAILURE" as const,
    payload: error,
});

export const approveLogoutRequest = (
    cabid: string,
    closingKM: string,
    username: string
) => ({
    type: "APPROVE_LOGOUT_REQUEST" as const,
    payload: { cabid, closingKM, username },
});

export const approveLogoutSuccess = (message: string) => ({
    type: "APPROVE_LOGOUT_SUCCESS" as const,
    payload: message,
});

export const approveLogoutFailure = (error: string) => ({
    type: "APPROVE_LOGOUT_FAILURE" as const,
    payload: error,
});

export const clearAttendanceMessage = () => ({
    type: "CLEAR_ATTENDANCE_MESSAGE" as const,
});

export const leaveApproveRequest = (
    cabid: string,
    reason: string,
    fromdate: string,
    todate: string
) => ({
    type: "LEAVE_APPROVE_REQUEST" as const,
    payload: { cabid, reason, fromdate, todate },
});

export const leaveApproveSuccess = (message: string) => ({
    type: "LEAVE_APPROVE_SUCCESS" as const,
    payload: message,
});

export const leaveApproveFailure = (error: string) => ({
    type: "LEAVE_APPROVE_FAILURE" as const,
    payload: error,
});

export const revertLogoutRequest = (
    cabid: string,
    username: string
) => ({
    type: "REVERT_LOGOUT_REQUEST" as const,
    payload: { cabid, username },
});

export const revertLogoutSuccess = (message: string) => ({
    type: "REVERT_LOGOUT_SUCCESS" as const,
    payload: message,
});

export const revertLogoutFailure = (error: string) => ({
    type: "REVERT_LOGOUT_FAILURE" as const,
    payload: error,
});

export const revertLoginRequest = (
    cabid: string,
    username: string
) => ({
    type: "REVERT_LOGIN_REQUEST" as const,
    payload: { cabid, username },
});

export const revertLoginSuccess = (message: string) => ({
    type: "REVERT_LOGIN_SUCCESS" as const,
    payload: message,
});

export const revertLoginFailure = (error: string) => ({
    type: "REVERT_LOGIN_FAILURE" as const,
    payload: error,
});

export const getLogoutDetailsRequest = (cabid: string) => ({
    type: "GET_LOGOUT_DETAILS_REQUEST" as const,
    payload: { cabid },
});

export const getLogoutDetailsSuccess = (data: any) => ({
    type: "GET_LOGOUT_DETAILS_SUCCESS" as const,
    payload: data,
});

export const getLogoutDetailsFailure = (error: string) => ({
    type: "GET_LOGOUT_DETAILS_FAILURE" as const,
    payload: error,
});

export const HOLD_DUTY_REQUEST = "HOLD_DUTY_REQUEST";
export const HOLD_DUTY_SUCCESS = "HOLD_DUTY_SUCCESS";
export const HOLD_DUTY_FAILURE = "HOLD_DUTY_FAILURE";

export const holdDutyRequest = (
    cabid: string,
    username: string,
    reason: string
) => ({
    type: HOLD_DUTY_REQUEST,
    payload: { cabid, username, reason },
});

export const RELEASE_HOLD_CAB_REQUEST = "RELEASE_HOLD_CAB_REQUEST";
export const RELEASE_HOLD_CAB_SUCCESS = "RELEASE_HOLD_CAB_SUCCESS";
export const RELEASE_HOLD_CAB_FAILURE = "RELEASE_HOLD_CAB_FAILURE";
export const RELEASE_HOLD_CAB_RESET = "RELEASE_HOLD_CAB_RESET";

export interface ReleaseHoldPayload {
    cabid: string;
    username: string;
}

export const releaseHoldCabRequest = (payload: ReleaseHoldPayload) => ({
    type: RELEASE_HOLD_CAB_REQUEST as typeof RELEASE_HOLD_CAB_REQUEST,
    payload,
});

export const releaseHoldCabSuccess = (message: string) => ({
    type: RELEASE_HOLD_CAB_SUCCESS as typeof RELEASE_HOLD_CAB_SUCCESS,
    payload: message,
});

export const releaseHoldCabFailure = (error: string) => ({
    type: RELEASE_HOLD_CAB_FAILURE as typeof RELEASE_HOLD_CAB_FAILURE,
    payload: error,
});

export const releaseHoldCabReset = () => ({
    type: RELEASE_HOLD_CAB_RESET as typeof RELEASE_HOLD_CAB_RESET,
});

export type ReleaseHoldActions =
    | ReturnType<typeof releaseHoldCabRequest>
    | ReturnType<typeof releaseHoldCabSuccess>
    | ReturnType<typeof releaseHoldCabFailure>
    | ReturnType<typeof releaseHoldCabReset>;


export const RESUME_DUTY_CAB_REQUEST = "RESUME_DUTY_CAB_REQUEST";
export const RESUME_DUTY_CAB_SUCCESS = "RESUME_DUTY_CAB_SUCCESS";
export const RESUME_DUTY_CAB_FAILURE = "RESUME_DUTY_CAB_FAILURE";

export const resumeDutyCabRequest = (cabid: string, username: string) => ({
    type: RESUME_DUTY_CAB_REQUEST,
    payload: { cabid, username },
});


// driverLocation
export const EDIT_DRIVER_LOCATION_REQUEST = "EDIT_DRIVER_LOCATION_REQUEST";
export const EDIT_DRIVER_LOCATION_SUCCESS = "EDIT_DRIVER_LOCATION_SUCCESS";
export const EDIT_DRIVER_LOCATION_FAILURE = "EDIT_DRIVER_LOCATION_FAILURE";

export const editDriverLocationRequest = (payload: {
    cabid: string;
    piclat: string;
    piclon: string;
    present_location: string;
    locationupdatedby: string;
}) => ({
    type: EDIT_DRIVER_LOCATION_REQUEST,
    payload
});

export const editDriverLocationSuccess = (data: any) => ({
    type: EDIT_DRIVER_LOCATION_SUCCESS,
    payload: data
});

export const editDriverLocationFailure = (error: any) => ({
    type: EDIT_DRIVER_LOCATION_FAILURE,
    payload: error
});

export const MAKE_CAB_AVAILABLE_REQUEST = 'booking/makeCabAvailableRequest';
export const MAKE_CAB_AVAILABLE_SUCCESS = 'booking/makeCabAvailableSuccess';
export const MAKE_CAB_AVAILABLE_FAILURE = 'booking/makeCabAvailableFailure';

export const makeCabAvailableRequest = (cabid: string) => ({
    type: MAKE_CAB_AVAILABLE_REQUEST,
    payload: { cabid },
});

export const makeCabAvailableSuccess = (data: any) => ({
    type: MAKE_CAB_AVAILABLE_SUCCESS,
    payload: data,
});

export const makeCabAvailableFailure = (error: any) => ({
    type: MAKE_CAB_AVAILABLE_FAILURE,
    payload: error,
});